<template>
  <v-container fluid style="margin-top:50px;">
    <v-layout class="font-number">
      <!-- MONTH -->
      <v-flex xs3 class="text-xs-left">{{ month }} {{ year }}</v-flex>
      <v-flex xs6 />
      <!-- WEEK -->
      <v-flex xs3>
        <v-layout row wrap>
          <v-flex xs6 />
          <v-flex xs5 class="text-xs-left">{{ $t("week") }}</v-flex>
          <v-flex xs1>{{ week }}</v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- DATE -->
    <v-layout class="font-number text-xs-center">
      <v-flex xs2 v-for="i in 7" :key="i">{{ checkDate(i) }}</v-flex>
    </v-layout>
    <!-- DAY -->
    <v-layout class="font-heading text-xs-center">
      <v-flex xs2 v-for="i in 7" :key="i">
        <div>{{ days[i-1] }}</div>
      </v-flex>
    </v-layout>
    <!-- CLASSES -->
    <v-layout>
      <v-flex
        xs2
        v-for="i in 7"
        :key="i"
        :class="dayStyle(i)">
        <v-flex
          xs12
          v-for="item in getDay(i-1)"
          :key="item.class"
          text-xs-center>
          <v-spacer>
            <br>
          </v-spacer>
          <v-layout row wrap>
            <!-- CLASS TIME -->
            <v-flex xs3 class="headline mt-1 ml-2 mr-2">{{ item.time }}</v-flex>
            <v-layout
              row
              wrap
              class="text-xs-left"
              :style="{'padding':'0px 0px 0px 3px'}">
              <!-- CLASS NAME -->
              <v-flex xs12>{{ getScheduledClass(item).name }}</v-flex>
              <!-- CLASS DURATION -->
              <v-flex xs6 class="font-subheading">{{ getScheduledClass(item).duration }} min</v-flex>
              <v-flex
                xs6
                class="font-subheading"
                v-if="item.type !== undefined && item.type === 'live'">
                LIVE
              </v-flex>
            </v-layout>
          </v-layout>
          <!-- CLASS ACCENT -->
          <v-flex
            class="classBar"
            :style="{ 'background-color':getScheduledClass(item).color}" />
          <v-spacer>
            <br>
          </v-spacer>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const moment = require("moment");
export default {
  data() {
    return {
      date: "",
      week: "",
      month: "",
      year: ""
    };
  },
  methods: {
    checkDate(i) {
      return moment()
        .startOf("isoweek")
        .add("days", i - 1)
        .date();
    },
    dayStyle(i) {
      if (i > 5) {
        return "weekendBack dayBorderRight";
      } 
      
      if (i >= 2 && i < 6) {
        return "dayBorderRight";
      } 

      return "dayBorderLeft dayBorderRight";
    },
    getScheduledClass(item) {
      if (item.type !== undefined && item.type === "live") {
        return item;
      } 
      const x = this.$store.getters.getVideos.find(video => video.id === item.classId);
      if (x === undefined) {
        return {
          name: "No video found",
          duration: 0,
          color: "grey"
        };
      } 
      return x;
        
      
    },
    getDay(day) {
      if (this.$store.getters.getSchedule[this.days[day].toLowerCase()]) {
        return this.$store.getters.getSchedule[this.days[day].toLowerCase()];
      } 
      return [];
      
    }
  },
  computed: {
    days() {
      moment.locale(this.$i18n.locale);
      const days = moment.weekdaysShort(true);
      moment.locale("en"); // switching locale back
      return days;
    },
    months() {
      moment.locale(this.$i18n.locale);
      const months = moment.months(false);
      moment.locale("en"); // switching locale back
      return months;
    }
  },
  created() {
    moment.updateLocale("en", {
      week: {
        dow: 1,
      },
    });
  },
  mounted() {
    this.week = moment().isoWeek();
    this.year = moment().year();
    this.month = this.months[moment().month()];
  }
};
</script>

<style>
.weekendBack {
  min-height: 700px;
  background: linear-gradient(#303030, #252525 20%, #252525 80%, #303030);
}

.dayBorderRight {
  border-right: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.dayBorderLeft {
  border-left: 2px solid;
  border-image: linear-gradient(
    to top,
    #303030,
    #707070 30%,
    #707070 70%,
    #303030
  );
  border-image-slice: 1;
}
.classBar {
  width: 90%;
  height: 8px;
  border-radius: 25px;
  background-color: red;
  box-shadow: 0px 4px 15px black;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue